'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactScroll = require('react-scroll');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _ramda = require('ramda');
var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _components = require('../../components');
var _containers = require('../../containers');

var _PublishPropertyPage = require('../../pages/PublishPropertyPage/PublishPropertyPage.scss');var styles = _interopRequireWildcard(_PublishPropertyPage);
var _PublishValidate = require('./PublishValidate');var _PublishValidate2 = _interopRequireDefault(_PublishValidate);
var _PublishForm = require('./PublishForm');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var PublishFinishBlock = function PublishFinishBlock(props) {var
  translate =
  props.translate,isEdit = props.isEdit,isForeign = props.isForeign,isMobile = props.isMobile,locale = props.locale,contacts = props.fields.contacts,editedProperty = props.editedProperty,isAgent = props.isAgent,isFreePackage = props.isFreePackage,shouldRenderPackagesBlock = props.shouldRenderPackagesBlock,virtualNumbers = props.virtualNumbers;
  var paymentIsRequired = shouldRenderPackagesBlock && !isFreePackage;var _ref =
  contacts || {},primary = _ref.primary,secondary = _ref.secondary;

  return (
    _react2.default.createElement('form', { onSubmit: props.handleSubmit(props.submitForm) },
      _react2.default.createElement(_components.PublishContactsBlock, {
        contacts: contacts,
        translate: translate,
        isMobile: isMobile,
        locale: locale,
        isRtl: props.isRtl,
        changeValue: props.changeValue,
        primaryContact: primary,
        secondaryContact: editedProperty ? secondary || editedProperty.contacts.secondary : null,
        contactsErrors: props.error && props.error.contacts,
        virtualNumbers: virtualNumbers,
        untouch: props.untouch,
        unregisterFormField: props.unregisterFormField }),


      shouldRenderPackagesBlock &&
      _react2.default.createElement(_containers.PackagesBlock, {
        translate: props.parsTranslate('PackageBlock'),
        saveDataToStorage: props.saveDataToStorage,
        locale: locale,
        isMobile: isMobile,
        isAgent: isAgent,
        selectedPackage: props.selectedPackage,
        changeSelectedPayment: props.changeSelectedPayment,
        needsScrollDown: props.isSuccessPaid || props.isRequestFailed,
        discountCoupon: props.discountCoupon,
        updateCoupon: props.setCouponCode,
        hasPhotos: !!(0, _get2.default)(props, 'fields.images.length') }),



      _react2.default.createElement(_reactScroll.Element, { name: 'publish', className: styles.requiredFieldsTitle },
        _react2.default.createElement('span', { className: (0, _classnames2.default)(styles.labelTop, styles.rowLabel) },
          translate('fieldRequired'), ' - ', _react2.default.createElement('span', { className: 'req' }, '*'))),


      _react2.default.createElement(_containers.SubmitBlock, {
        translate: translate,
        isEdit: isEdit,
        isForeign: isForeign,
        submitting: props.submitting,
        uploadInProgress: props.uploadInProgress,
        fields: props.fields,
        openPreviewDetailsPopup: props.openPreviewDetailsPopup,
        errors: props.error,
        handleSubmit: props.handleSubmit,
        config: props.config,
        propertyId: props.propertyId,
        userData: props.userData,
        paymentIsRequired: paymentIsRequired,
        sendPaymentRequest: props.openDetailsToInvoiceForm,
        iframeLoading: props.iframeLoading,
        place: props.geocodedPlace })));



};

PublishFinishBlock.propTypes = {
  translate: _propTypes2.default.func,
  parsTranslate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  isEdit: _propTypes2.default.bool,
  isAgent: _propTypes2.default.bool,
  propertyId: _propTypes2.default.string,
  shouldRenderPackagesBlock: _propTypes2.default.bool,
  isFreePackage: _propTypes2.default.bool,
  editedProperty: _propTypes2.default.object,
  selectedPackage: _propTypes2.default.object,
  userData: _propTypes2.default.object,
  geocodedPlace: _propTypes2.default.object,
  config: _propTypes2.default.object,
  changeValue: _propTypes2.default.func,
  saveDataToStorage: _propTypes2.default.func,
  changeSelectedPayment: _propTypes2.default.func,
  setCouponCode: _propTypes2.default.func,
  openPreviewDetailsPopup: _propTypes2.default.func,
  openDetailsToInvoiceForm: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  submitForm: _propTypes2.default.func,
  fields: _propTypes2.default.object,
  error: _propTypes2.default.object,
  virtualNumbers: _propTypes2.default.array,
  isSuccessPaid: _propTypes2.default.bool,
  isRequestFailed: _propTypes2.default.bool,
  iframeLoading: _propTypes2.default.bool,
  discountCoupon: _propTypes2.default.object,
  submitting: _propTypes2.default.bool,
  uploadInProgress: _propTypes2.default.bool,
  unregisterFormField: _propTypes2.default.func,
  untouch: _propTypes2.default.func,
  isForeign: _propTypes2.default.bool };


var unregisterFormField = function unregisterFormField(name) {return (0, _reduxForm.unregisterField)('PublishForm', name);};exports.default =

(0, _ramda.compose)(
(0, _reactRedux.connect)(null, { unregisterFormField: unregisterFormField }),
(0, _reduxForm.reduxForm)({
  form: 'PublishForm',
  destroyOnUnmount: false,
  validate: _PublishValidate2.default,
  onSubmitFail: function onSubmitFail(errors) {return errors && (0, _PublishForm.scrollToFirstError)(errors);} }))(

PublishFinishBlock);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishForm/PublishFinishBlock.js
// module id = 2990
// module chunks = 0